<template>
    <div class="pop" v-show="show" @click.stop='_=>{}'>
        <div class="box">
            <div class="title">{{title}}</div>
            <div class="wrap">
                {{text}}
                <img style="margin-top:10px;" :src='url' />
                <div style='text-align:center;'>
                    <button class="btn" @click="success">
                        <span v-show='!loading'>支付成功</span>
                        <span v-show='loading'>
                            loading
                            <i class="i1"></i>
                            <i class="i2"></i>
                            <i class="i3"></i>
                        </span>
                    </button>
                    <button class="btn" @click="fail">支付失败</button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'agree',
        data: () => ({
            show: true,
            loading: false
        }),
        props: {
            title: {
                default: '提示',
                type: String
            },
            url: {
                default: '',
                type: String
            },
            text: {
                default: '',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            cancelCall: {
                default: () => {},
                type: Function
            }
        },
        methods: {
            close() {
                this.show = false
            },
            load () {
                this.loading = true
            },
            finish () {
                this.loading = false
                this.close()
            },
            close_load (){
                this.loading = false
            },
            success() {
                this.confirmCall(this.load,this.finish, this.close_load)
            },
            fail() {
                this.cancelCall()
                this.close()
            }
        },
        components: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 494px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
        text-align: center;
    }

    .btn {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 0;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        width: 110px;
        zoom: 1;
        border: 0;
        outline: 0;
        margin: 25px 10px 0;
    }


    .btn i {
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: white;
        margin: 0 1px;
    }

    @keyframes flash1 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 1;
        }

        66% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes flash2 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 0;
        }

        66% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes flash3 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 0;
        }

        66% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .btn .i1 {
        animation: flash1 1s ease infinite;
    }

    .btn .i2 {
        animation: flash2 1s ease infinite;
    }

    .btn .i3 {
        animation: flash3 1s ease infinite;
    }

    
    /* @media screen and (max-width: 494px) {
        .box {width: 100%;}
        .wrap {
            padding:30px 20px;
        }
        .btn {
            width: 30%;
            margin: 25px 5% 0;
        }
    } */
</style>